import { Component } from '@angular/core';
import { MatInputModule } from '@angular/material/input';

@Component({
  selector: 'app-connect-opa-footer',
  imports: [MatInputModule],
  templateUrl: './connect-opa-footer.component.html',
  styleUrls: ['./connect-opa-footer.component.scss'],
})
export class ConnectOpaFooterComponent {}
